export const ENV = process.env.REACT_APP_RUN_ENV === "PRDUSE" ? "Prod" : (process.env.REACT_APP_RUN_ENV === "PREUSE" ? "PreProd" : "Local" );

